import { render, staticRenderFns } from "./GreyButton.vue?vue&type=template&id=4ca9c303&scoped=true&"
import script from "./GreyButton.vue?vue&type=script&lang=js&"
export * from "./GreyButton.vue?vue&type=script&lang=js&"
import style0 from "./GreyButton.vue?vue&type=style&index=0&id=4ca9c303&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca9c303",
  null
  
)

export default component.exports